import React from "react";

export default function RegisteredCustomersReports() {
  const data = [
    { period: "In the last 7 days", count: 10 },
    { period: "In the last 14 days", count: 10 },
    { period: "In the last month", count: 10 },
    { period: "In the last year", count: 10 },
  ];

  return (
    <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <h1 className="text-xl font-semibold text-gray-800 mb-4">
        Registered Customers
      </h1>

      {/* Learn More */}
      <a
        href="#"
        className="text-blue-600 text-sm hover:underline mb-4 inline-block"
      >
        Learn more about reports
      </a>

      {/* Table */}
      <div className="overflow-x-auto bg-white rounded-lg shadow-sm">
        <table className="min-w-full text-sm text-left">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="py-3 px-4 font-medium">Period</th>
              <th className="py-3 px-4 font-medium">Count</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => (
              <tr key={i} className="border-t hover:bg-gray-50">
                <td className="py-3 px-4">{row.period}</td>
                <td className="py-3 px-4">{row.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col md:flex-row items-center justify-between mt-4 text-sm text-gray-600">
        {/* Prev / Next */}
        <div className="flex items-center gap-2 mb-2 md:mb-0">
          <button className="px-3 py-1 border rounded hover:bg-gray-100">
            Previous
          </button>
          <span>1</span>
          <button className="px-3 py-1 border rounded hover:bg-gray-100">
            Next
          </button>
        </div>

        {/* Show items */}
        <div className="flex items-center gap-2 mb-2 md:mb-0">
          <span>Show</span>
          <select className="border border-gray-300 rounded-md px-2 py-1">
            <option>15</option>
            <option>30</option>
            <option>50</option>
          </select>
          <span>items</span>
        </div>

        {/* Range info */}
        <p>1–4 of 4 items</p>
      </div>
    </div>
  );
}
